/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  appButton: {
    padding: '0.5rem',
    borderRadius: '6px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    fontWeight: 600,
  },
};

function AppIconButton({
  btnText,
  variant,
  btnType,
  onClick,
  className,
  children,
  ...rest
}) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={btnType}
      onClick={onClick}
      style={styles.appButton}
      className={`app-btn-${variant} ${className}`}
      {...rest}
    >
      {children} {btnText}
    </button>
  );
}

AppIconButton.defaultProps = {
  className: '',
  variant: 'primary',
  btnText: '',
  btnType: 'button',
};

AppIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  btnText: PropTypes.string,
  btnType: PropTypes.oneOf(['submit', 'button', 'reset']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'outlined',
    'transparent',
    'white',
  ]),
  className: PropTypes.string,
};

export default AppIconButton;
